import { formatDateRange } from '@mntn/formatters'
import { Text } from '@mntn/ui-components'

type FlightDateRangeProps = {
  flightStartTime?: string | null
  flightEndTime?: string | null
}

/**
 * The flight window the buyer chose at checkout. Flight dates are optional on
 * an order item, so this renders nothing unless both bounds are set — which is
 * why the design shows the line on some cards and not others.
 */
export function FlightDateRange({ flightStartTime, flightEndTime }: FlightDateRangeProps) {
  const range = formatDateRange(flightStartTime, flightEndTime)
  if (!range) return null

  return (
    <Text variant="base-sm" className="text-secondary">
      Date Range: {range}
    </Text>
  )
}
